export default __webpack_public_path__ + "static/media/template7.aab241fb.jpg";